import React, { useState } from "react";
import {Grid, Typography, Paper, Snackbar, Alert, Button, IconButton} from "@mui/material";
import CameraEnhanceIcon from "@mui/icons-material/CameraEnhance";
import {ImageWrapper, ImageIconButton, IconButtonWrapper} from "./styles";
import { useNavigate } from "react-router-dom";
import SideBar from "../../../../components/dealer/Inspection/SideBar";

const images = [
  {
    title: "Front"
  },
  {
    title: "Right"
  },
  {
    title: "left"
  },
  {
    title: "Rear"
  },
  {
    title: "Odometer"
  }
];

const secondaryImages = [
  {
    title: "Image 1"
  },
  {
    title: "Image 2"
  },
  {
    title: "Image 3"
  },
  {
    title: "Image 4"
  },
  {
    title: "Image 5"
  }
];

const DealerInspectionImages = () => {
  const [selectedImages, setSelectedImages] = useState([]);

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  const navigate = useNavigate();

  const handleConfirm = () => {
    navigate("/customer/status");
  };

  const handleImageChange = (event, title) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImages(prevImages => ({ ...prevImages, [title]: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="start" style={{ margin: "25px 0", minHeight: 700 }}>
      {/* Left column */}
      <Grid item xs={12} md={4} sx={{pr: 2}}>
        <SideBar />
      </Grid>

      {/* Right column */}
      <Grid item xs={12} md={8}>
        <Paper elevation={3} style={{ padding: "20px" }}>
          <Typography variant="h5">Main Images</Typography>

          {/* Image selection icons */}
          <ImageWrapper>
            {images.map((item, index) => (
              <ImageIconButton key={index}>
                <Typography variant="h6">{item.title}</Typography>
                <IconButtonWrapper>
                  {selectedImages[item.title] ? (
                    <img src={selectedImages[item.title]} alt={item.title} style={{ maxWidth: "100px", maxHeight: "100px" }} />
                  ) : (
                    <label htmlFor={`image-upload-${index}`}>
                      <input
                        style={{ display: "none" }}
                        id={`image-upload-${index}`}
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageChange(e, item.title)}
                      />
                      <IconButton component="span">
                        <CameraEnhanceIcon color="secondary" fontSize="large" />
                      </IconButton>
                    </label>
                  )}
                </IconButtonWrapper>
              </ImageIconButton>
            ))}
          </ImageWrapper>

          <Typography variant="h5">Other Images</Typography>

          <ImageWrapper>
            {secondaryImages.map((item, index) => (
              <ImageIconButton key={index}>
                <Typography variant="h6">{item.title}</Typography>
                <IconButtonWrapper>
                  {selectedImages[item.title] ? (
                    <img src={selectedImages[item.title]} alt={item.title} style={{ maxWidth: "100px", maxHeight: "100px" }} />
                  ) : (
                    <label htmlFor={`image-upload-${index}`}>
                      <input
                        style={{ display: "none" }}
                        id={`image-upload-${index}`}
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageChange(e, item.title)}
                      />
                      <IconButton component="span">
                        <CameraEnhanceIcon color="secondary" fontSize="large" />
                      </IconButton>
                    </label>
                  )}
                </IconButtonWrapper>
              </ImageIconButton>
            ))}
          </ImageWrapper>
          <Button variant="contained" color="primary" onClick={() => handleConfirm()}>
            Submit
          </Button>
        </Paper>
      </Grid>

      {/* Snackbar */}
      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: "100%" }}>
          {/*{error or "An error occurred"}*/}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default DealerInspectionImages;
